import {Aos} from './aos'
import {findAndGenerateSelectorsStyle} from './selector'
import {HashScroll} from './hash-scroll'
import {initFlexible} from './flexibles'
import './marketo'
import './koalaboox'
import {MenuLang} from './menu-lang'
import {MenuPrimary} from './menu-primary'
import {NavTop} from './nav-top'
import {Modal} from './modal'
import {Search} from './search'
import {Slider} from './slider'
import {Tabs} from './tabs'
import {Sticky} from './sticky'
import {OutroSticky} from './outro-sticky'
import {TimingCircle} from './timing-circle'
import {Tracking} from './tracking'
import {TableContent} from './table-content'
import './active-script.js'
import {ProgressBar} from "./progress-bar.js"
import {BackToTop} from "./back-to-top.js"
import {ScrollDown} from "./scroll-down.js"
import {SingleNewsletter} from "./single-newsletter"
import {Hubspot} from './hubspot'
import {Link} from './link'
import {TemplateExalogSimulator} from "./template-exalog-simulator.js"
import {StorylaneApp} from "./storylane-app.js"
import {SingleReadingTime} from "./single-reading-time.js"
import {SentryConfig} from "./sentry-config.js"
import {Tolkai} from "./tolkai.js";
import {Forms} from "./forms.js";
import {OdooForm} from "./odoo-form.js";
import {PhcGoLogin} from "./phc-go-login.js";
import {PhcGoTrial} from "./phc-go-trial.js";
import {ResiliationSilae} from "./resiliation-silae.js";
import BannerTop from './banner-top.js';
import {VideoLoading} from './video-loading.js';

new SentryConfig();
new ProgressBar()
new Aos()
new Tabs()
new MenuLang()
new Modal()
new Search()
new Slider()
new Sticky()
new OutroSticky()
new TimingCircle()
new SingleNewsletter()
new HashScroll()
new Tracking()
new MenuPrimary()
new NavTop()
new TableContent()
new BackToTop()
new ScrollDown()
new Hubspot()
new Link()
new TemplateExalogSimulator()
new StorylaneApp()
new SingleReadingTime()
new Tolkai()
new Forms()
new OdooForm()
new PhcGoLogin()
new PhcGoTrial()
new ResiliationSilae()
new BannerTop()
new VideoLoading()

initFlexible()
findAndGenerateSelectorsStyle()
